import React from "react";
import { Github, Mail, Globe } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-800 text-slate-300 py-4 px-8 w-full h-[64px] shrink-0">
      <div className="container mx-auto h-full">
        <div className="flex justify-between items-center h-full">
          {/* Company/Product Info */}
          <div className="text-left">
            <h3 className="font-semibold text-white">Stope Recovery</h3>
            <p className="text-sm">Version 1.0.0 | MineExcellence</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
